import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import capitalize from 'scaleflow/utils/capitalize';

export default class RoadmapFilterSlideoverIndexComponent extends Component {
  @service intl;

  get options() {
    return [
      {
        label: capitalize(
          this.intl.t('_initiatives.source', {
            num: 1,
          }),
        ),
        value: 'source',
      },
      {
        label: capitalize(this.intl.t('_initiatives.status')),
        value: 'status',
      },
      {
        label: capitalize(
          this.intl.t('_initiatives.teams', {
            num: 1,
          }),
        ),
        value: 'teams',
      },
      {
        label: capitalize(
          this.intl.t('_initiatives.themes', {
            num: 1,
          }),
        ),
        value: 'theme',
      },
      {
        label: capitalize(this.intl.t('_initiatives.progress')),
        value: 'latestUpdate',
      },
      {
        label: capitalize(
          this.intl.t('dictionary.goals', {
            num: 1,
          }),
        ),
        value: 'goals',
      },
    ];
  }

  @action
  excludeSelectedRowOption() {
    return this.options.filter((item) => item.value !== this.args.row);
  }

  @action
  excludeSelectedColumnOption() {
    return this.options.filter((item) => item.value !== this.args.column);
  }

  @action
  propagateRowUpdate(e) {
    this.args?.onRowSelect(e.value);
  }

  @action
  propagateColumnUpdate(e) {
    this.args?.onColumnSelect(e.value);
  }
}
